import axios, { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";
import { ResponsePhaseGet, ResponsePhaseGetId, ResponsePhasePost } from "./interfacePhase";


export const getPhase = async (): Promise<ResponsePhaseGetId[]> => {
    try {
        const data = await getApi('/phase');
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsePhaseGetId[];
    }
}


export const getPhaseYear = async (year?: string): Promise<ResponsePhaseGetId[]> => {
    try {
        const data = await getApi(`/phase/year/${year ? year : ""}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsePhaseGetId[];
    }
}


interface Body {
    startDate: string,
    endDate: string,
    type: string,
    yearId: number,
    status: boolean
}

export const postPhase = async (body: Body): Promise<ResponsePhasePost> => {
    try {
        const data = await postApi('/phase', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsePhasePost;
    }
}


export const patchPhase = async (body: Body, id?:number): Promise<ResponsePhaseGet> => {
    try {
        const data = await patchApi(`/phase/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsePhaseGet;
    }
}



export const getPhaseId = async (term?: number): Promise<ResponsePhaseGetId> => {
    try {
        const data = await getApi(`/phase/${term}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsePhaseGetId;
    }
}

export const deletePhase = async (term: number): Promise<any> => {
    try {
        const data = await deleteApi(`/phase/${term}`, term);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}